import Vue from 'vue'
import { login } from '@/plugins/api/user'

const state = {
  id: '',
  token: '',
  access_token: '', // Vue.ls.get('access_token') ? Vue.ls.get('access_token') : '', // Vue.ls.get('access_token'),
  name: '',
  avatar: '',
  roles: [],
  permission: [], // router use,
  isLogin: false // Vue.ls.get('is_login')// false,
}

const mutations = {
  SET_ID: (state, id) => {
    state.id = id
    Vue.ls.set('sid', id)
  },
  SET_TOKEN: (state, token) => {
    state.token = token
    Vue.ls.set('token', token)
  },
  SET_REFRESH_TOKEN: (state, token) => {
    state.access_token = token
    Vue.ls.set('access_token', token)
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSION: (state, { permission }) => {
    state.permission = permission
  },
  SET_DEFAULT: (state) => {
    Vue.ls.clear()
    state.id = null
    state.token = ''
    state.access_token = ''
    state.name = ''
    state.avatar = ''
    state.roles = []
    state.permission = []
    state.isLogin = false
  },
  LOGIN (state, payload) {
    Vue.ls.set('isLogin', payload)
    state.isLogin = payload
  }
}

const actions = {
  login ({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ account: username.trim(), password: password }).then(response => {
        const { code, data } = response
        if (code === 1000) {
          // eslint-disable-next-line camelcase
          const { access_token, refresh_token } = data
          commit('SET_TOKEN', access_token)
          commit('SET_REFRESH_TOKEN', refresh_token)
          commit('LOGIN', true)
          return resolve()
        }
        // eslint-disable-next-line prefer-promise-reject-errors
        return reject()
      }).catch(error => {
        reject(error)
      })
    })
  },
  logout ({ dispatch }) {
    dispatch('setDefault')
  },
  setDefault ({ commit }) {
    commit('SET_DEFAULT')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
